<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<div class="funny-progress" v-if="$store.state.funny_progress === true">
					<iframe src="https://giphy.com/embed/ZXKZWB13D6gFO" width="480" height="289" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/bored-alice-in-wonderland-meh-ZXKZWB13D6gFO"></a></p>
				</div>
				<div class="card">
					<div class="card-body">
						<div class="goal" style="text-align:center;width:100%;height:83px;" v-on:dblclick="$bvModal.show('bv-modal-year-price')">
							<span><h4 id="goalBlinkWeek">{{tableData.year}}</h4></span>
							<img src="static/img/logo.png" alt="" style="width:35%;margin-top:14px;">
						</div>
							<table class="table table-striped table-dark">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Имя менеджера</th>
										<th scope="col">Кол-во звонков</th>
										<th scope="col">Кол-во времени</th>
										<th scope="col">Сумма Сделок</th>
										<th scope="col">Счета/День</th>
<!--										<th scope="col">Записи на вебинар</th>
										<th scope="col">КЭВ назначен</th>
										<th scope="col">КЭВ пройден</th>
										<th scope="col">Норма по дням</th>
										-->
										<th scope="col">ЦКП/День</th>
										<th scope="col">ЦКП/Неделя</th>
<!--										<th scope="col">Премия</th>-->
									</tr>
								</thead>
								<tbody>
									<tr v-for="(tableDatas, index) in tableData.users" :key="tableDatas.id">
											<td class="align-middle">
												<div class="king" v-if="index === 0 && tableDatas.invoicesumweek > '0'">
													<img src="/static/img/king.png" alt="">
												</div>
												<div class="loser" v-else-if="tableDatas.invoicesumweek < '0'">
													<img src="/static/img/loser.png" alt="">
												</div>
												<div class="loser" v-else>
													<img src="/static/img/loser-null.png" alt="">
												</div>
												<div class="avatars avatar">
													<img :src="tableDatas.photo" alt="">
												</div>
											</td>
											<td scope="row" class="font-width align-middle">
												{{tableDatas.name}} <br> {{tableDatas.last_name}}
											</td>
											<td>
												<div id="chart">
													<apexchart type="radialBar" height="300" width="200" :options="chartOptions" :series="[Math.trunc((tableDatas.callcount * 100) / 50)]" />
												</div>
												Количество звонков: {{tableDatas.callcount}}
											</td>
											<td>
												<div id="chart">
													<apexchart type="radialBar" height="300" width="200" :options="chartOptions" :series="[Math.trunc((tableDatas.calltimes * 100) / 140)]" />
												</div>
												Количество минут: {{tableDatas.calltimes}}
											</td>
										<td class="font-width align-middle">
											{{tableDatas.dealcount}}
										</td>
											<td class="font-width align-middle">
												{{tableDatas.invoice_all}}
											</td>
<!--											<td class="font-width align-middle">-->
<!--												{{tableDatas.webinar}}-->
<!--											</td>
											<td class="font-width align-middle">
												{{tableDatas.kev_assigned}}
											</td>
											<td class="font-width align-middle">
												{{tableDatas.kev_passed}}
											</td>
											<td class="align-middle">
												<table>
													<tr>
														<td v-for="tableDatass in tableDatas.callresult" :key="tableDatass.week">
															{{tableDatass.weekrus}}
														</td>
													</tr>
													<tr>
														<td v-for="tableDatass in tableDatas.callresult" :key="tableDatass.week">
															<div v-if="tableDatass.count >= 40 && Math.trunc(tableDatass.times / 60) >= 90" style="background:green; padding-left:2px">
																<i class="fa fa-check" aria-hidden="true"></i>
															</div>
															<div v-else style="background:red; padding-left:2px">
																<i class="fa fa-times" aria-hidden="true"></i>
															</div>
														</td>
													</tr>
												</table>
											</td>
											-->
											<td class="font-width align-middle">
												{{tableDatas.invoicesum}}
											</td>
											<td class="font-width align-middle">
												{{parseInt(tableDatas.invoicesumweek)}}
											</td>
<!--											<td class="font-width align-middle">-->
<!--												{{tableDatas.quarterinvoicesum}}-->
<!--											</td>-->
									</tr>
								</tbody>
							</table>
					</div>
				</div>
				<b-modal id="bv-modal-year-price" centered hide-footer title="Установить цель недели">
					<input type="text" v-model="weekGoal">
					<button type="button" class="btn card-header-actions__item btn-primary" @click="setChangeYearPrice">Сохранить</button>
				</b-modal>
			</div>
		</div>
	</div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import VueSpeedometer from 'vue-speedometer'
export default {
	components: {
		apexchart: VueApexCharts,
		VueSpeedometer
	},
	data () {
		return {
			weekGoal: null,
			chartOptions: {
				chart: {
					offsetY: -20,
					foreColor: '#e7e7e7'
				},
				plotOptions: {
					radialBar: {
						startAngle: -90,
						endAngle: 90,
						track: {
							background:	'#e7e7e7',
							strokeWidth: '97%',
							margin: 5, // margin is in pixels
							shadow: {
								enabled: true,
								top: 2,
								left: 0,
								color: '#ffffff',
								opacity: 1,
								blur: 2
							}
						},
						dataLabels: {
							name: {
								show: false
							},
							value: {
								offsetY: -2,
								fontSize: '22px'
							}
						}
					}
				},
				fill: {
					colors: [function ({value}) {
						if (value < 55) {
							return '#D9534F'
						} else if (value >= 55 && value < 100) {
							return '#d5e038'
						} else {
							return '#38e041'
						}
					}],
					type: 'gradient',
					gradient: {
						shade: 'dark',
						shadeIntensity: 0.5,
						inverseColors: true,
						opacityFrom: 1,
						opacityTo: 1,
						stops: [0, 50, 53, 91]
					}
				},
				labels: ['Average Results']
			},
			tableData: []
		}
	},
	created () {
		this.getMonitor()
	},
	methods: {
		getMonitor () {
			this.$http.get(this.$store.state.apiURL + '/v3/monitors', {}, {
			}).then(function (response) {
				this.tableData = response.body
			}, function (response) {
			})
		},
		setChangeYearPrice () {
			this.$http.post(this.$store.state.apiURL + '/v3/monitors', {weekGoal: this.weekGoal}, {
			}).then(function (response) {
				this.getMonitor()
				console.log('sdfsdf')
			}, function (response) {
			})
		}
	},
	mounted () {
		setInterval(() => {
			this.getMonitor()
		}, 60000)
	}
}

</script>
<style scoped>
	.table-dark {
		color: #ffffff;
		font-weight: bolder;
	}
	.table-dark .font-width {
		font-size: 2vw;
	}
	.table-dark th, .table-dark td, .table-dark thead th {
		font-size: 20px;
		background-color: #000000;
	}
	.table-dark th {
		text-transform: uppercase;
	}
	.avatar {
		top: -31px;
		width: 110px ;
		height: 110px;
	}
	.avatar img {
		width: 110px ;
		height: 110px;
	}
	.king img {
		width: 70px;
		height: 70px;
		position: relative;
		top: 0px;
		left: 67px;
		z-index: 1;
		transform: rotate(
			45deg
		);
	}
	.loser img {
		width: 70px;
		height: 70px;
		position: relative;
		top: 0px;
		left: 67px;
		z-index: 1;
		transform: rotate(
			45deg
		);
	}
	#goalBlinkWeek {
		-webkit-animation: goalBlinkWeek 2s linear infinite;
		animation: goalBlinkWeek 2s linear infinite;
		text-transform: uppercase;
		margin: 0px 0px 15px;
		font-size: 3.5vw;
		color: rgb(220, 28, 28);
		float: left;
	}
	@-webkit-keyframes goalBlinkWeek {
		100% { color: rgba(28, 79, 220, 1); }
		50% { color: rgba(183, 37, 37, 0.3); }
		100% { color: rgba(28, 79, 220, 1); }
	}
	@keyframes goalBlinkWeek {
		100% { color: rgba(28, 79, 220, 1); }
		50% { color: rgba(183, 37, 37, 0.3); }
		100% { color: rgba(28, 79, 220, 1); }
	}

	#goalBlink {
		-webkit-animation: goalBlink 2s linear infinite;
		animation: goalBlink 2s linear infinite;
		text-transform: uppercase;
	}
	@-webkit-keyframes goalBlink {
		100% { color: rgba(220, 28, 28, 1); }
		50% { color: rgba(183, 37, 37, 0.3); }
		100% { color: rgba(220, 28, 28, 1); }
	}
	@keyframes goalBlink {
		100% { color: rgba(220, 28, 28, 1); }
		50% { color: rgba(183, 37, 37, 0.3); }
		100% { color: rgba(220, 28, 28, 1); }
	}

</style>



// WEBPACK FOOTER //
// src/pages/monitor/progress.vue